import { useId } from 'react';

import { Icon, IconKey } from '@/shared/components';
import { Checkbox } from '../ui/checkbox';
import { Field, FieldError, FieldLabel } from '../ui/field';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';

interface FieldCheckboxProps {
  id?: string;
  label: string;
  description?: string;
  errors?: Array<{ message?: string } | undefined>;
  checked?: boolean;
  required?: boolean;
  disabled?: boolean;
  onCheckedChange: (checked: boolean) => void;
}

export function FieldCheckbox({
  id,
  label,
  description,
  errors,
  checked = false,
  required = false,
  disabled = false,
  onCheckedChange
}: FieldCheckboxProps) {
  const internalId = useId();
  const checkboxId = id ?? internalId;

  return (
    <Field orientation='horizontal' data-invalid={errors?.some((e) => e?.message) ? 'true' : undefined}>
      <Checkbox
        id={checkboxId}
        checked={checked}
        disabled={disabled}
        onCheckedChange={(value) => onCheckedChange(value === true)}
        aria-invalid={errors?.some((e) => e?.message) ? 'true' : undefined}
      />

      <FieldLabel htmlFor={checkboxId} className='flex items-center gap-1'>
        {label} {required && <span className='text-destructive'>*</span>}
        {description && (
          <Tooltip>
            <TooltipTrigger asChild>
              <Icon icon={IconKey.HelpCircle} size={12} className='text-muted-foreground' />
            </TooltipTrigger>
            <TooltipContent>{description}</TooltipContent>
          </Tooltip>
        )}
      </FieldLabel>

      <FieldError errors={errors} />
    </Field>
  );
}
